import { useEntitlements } from '@/hooks/useEntitlements';

/**
 * Mounts entitlements once for the protected app shell (billing cache + Gate).
 * Renders nothing; LifecycleBanner and feature gates read the same hook state.
 */
export function EntitlementsBootstrap() {
  useEntitlements();
  return null;
}
